export const API_URLS = {
    BLOGS: 'blogs',
    BLOG_DETAIL: (slug) => `blogs/${slug}`,
    TERMS_AND_CONDITIONS: 'term-and-conditions',
    CANCELLATION_POLICY: 'cancellation-policy',
    COUPONS: 'coupons',
    FAQS: 'faqs',
    PRIVACY_POLICY: 'privacy-policy',
    CONTACT_DETAILS: 'contact-details',
    CONTACT_MESSAGE: 'contact-message',
    PROPERTIES_SEARCH: 'properties/search',
    TOP_RATED_PROPERTIES: 'properties/top-rated',
    PROPERTY_DETAIL: (id) => `properties/${id}`,
    // Clean Hotel & Global Inventory Endpoints (No ratehawk prefix)
    HOTELS_SEARCH: 'hotels/search',
    HOTEL_DETAIL: (id) => `hotels/${id}`,
    LOCATION_SUGGEST: 'suggest',
    BOOKING_PREBOOK: 'bookings/prebook',
    CREATE_HOTEL_BOOKING: 'bookings/create-hotel-booking',
    BOOKING_STATUS: (orderId) => `bookings/${orderId}/status`,

    // Compatibility aliases
    RATEHAWK_SEARCH: 'hotels/search',
    RATEHAWK_DETAIL: (id) => `hotels/${id}`,
    RATEHAWK_SUGGEST: 'suggest',
    RATEHAWK_PREBOOK: 'bookings/prebook',
    RATEHAWK_CREATE_BOOKING: 'bookings/create-hotel-booking',
    RATEHAWK_BOOKING_STATUS: (orderId) => `bookings/${orderId}/status`,
};
